import { _decorator, Enum } from 'cc';
import { DEV } from 'cc/env';

const { ccclass, property } = _decorator;

// 節點行為
export enum OrientationLimitType {
    NoLimit,
    LimitLandscape,
    LimitPortrait,
}

@ccclass('BaseAction')
export default class BaseAction {
    @property({ type: Enum(OrientationLimitType), displayName: DEV && '直橫版限制', tooltip: DEV && '是否因為當前直橫式狀態決定是否播放' })
    public readonly orientationLimit: OrientationLimitType = OrientationLimitType.NoLimit;
}
